import React, { Component } from 'react'
import { Text, View, TouchableOpacity, StyleSheet ,Image} from 'react-native'
import { ChevronRightIcon, ChevronPlayIcon } from '../../ui/components/Icons'
import { VideoDisplay } from '../../ui';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

export default class NutritionStepWithVideo extends Component {
    getDuration = (durationInSeconds) => {
        if (!durationInSeconds) {
            return '';
        }
        if (durationInSeconds < 60) {
            return `${durationInSeconds}sec`;
        }
        const minutes = durationInSeconds / 60;
        return `${Math.ceil(minutes)}min`
    }

    render() {
        const { nutritionStepInfo, stepNumber, openVideo, videoName } = this.props;
        const duration = this.getDuration(nutritionStepInfo.duration);
        return (
            <TouchableOpacity onPress={() => openVideo(videoName, nutritionStepInfo)} style={styles.stepContainer}>
                <TouchableOpacity onPress={() => openVideo(videoName, nutritionStepInfo)}
                    style={styles.openVideoContainer}>
                        <Image
                        style={{ 
                            flex: 1,
                            width: '100%',
                            height: '100%',
                            resizeMode: 'cover' }}
                        resizeMode='cover'
                        source={nutritionStepInfo.imageName}
                    />
                    <View style={styles.ChevronPlayIcon}>
                        <ChevronPlayIcon width={60} height={60} color={Theme.PRIMARY} />
                    </View>
                    <View style={styles.durationTextContainer}>
                        <Text style={styles.durationText}>
                            {duration}
                        </Text>
                    </View>
                </TouchableOpacity>
                <View style={styles.stepInfoContainer}>
                    <Text style={styles.stepHeadingText}>{`Step ${stepNumber}: `} {nutritionStepInfo.title}</Text>
                    <Text style={styles.stepSubHeadingText}>{nutritionStepInfo.description}</Text>
                </View>
                <View style={styles.chevronLineContainer}>
                    <View style={styles.verticalSeparator} />
                    <View style={styles.chevronContainer}>
                        <ChevronRightIcon width={18} height={18} color={Theme.PRIMARY} />
                    </View>
                </View>
            </TouchableOpacity>
        )
    }
}

const styles = StyleSheet.create({
    stepContainer: {
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        backgroundColor: Theme.GREY_LIGHT,
        marginVertical: defaultScale(5),
        borderRadius: 3,
        alignItems:'center',
        minHeight: 100 
    },
    openVideoContainer: {
        width: '33%', 
        height: defaultScale(90), 
        margin: defaultScale(10),
        backgroundColor:'black'
    },
    ChevronPlayIcon: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        justifyContent: 'center',
        alignItems: 'center'
    },
    durationTextContainer: {
        position: 'absolute',
        zIndex: 10,
        alignSelf: 'flex-end',
        bottom: 0,
    },
    durationText: {
        ...Theme.textStyle.bodyCopyBold,
        color: Theme.WHITE,
        padding: defaultScale(5),
    },
    stepInfoContainer: {
        alignSelf: 'center',
        marginHorizontal: defaultScale(5),
        width:'50%'
    },
    stepHeadingText: {
        ...Theme.textStyle.bodyCopyBold,
        paddingVertical: defaultScale(3),
    },
    stepSubHeadingText: {
        ...Theme.textStyle.small,
        paddingVertical: defaultScale(3),
        color: Theme.GREY_DARK_MEDIUM
    },
    chevronLineContainer: {
        flexDirection: 'row',
        height: '100%',
        width:'10%',
        justifyContent: 'space-evenly'
    },
    chevronContainer: {
        alignSelf: 'center',
        paddingVertical: defaultScale(5)
    },
    verticalSeparator: {
        width: 1,
        marginVertical: defaultScale(10),
        backgroundColor: Theme.GREY_MEDIUM_LIGHT,
    },

})
